module.exports = __webpack_public_path__ + "img/duizhangdan.97f1de4f.png";